<template>
  <div
    class="relative"
    :class="[
      SSectionVerticalMarginClasses,
      SSectionBackgroundColorsClasses[backgroundColor],
    ]"
  >
    <TContainer>
      <TGrid>
        <div class="col-span-12" :class="SSectionverticalPaddingClasses">
          <TTitle
            v-if="title && title.length > 0"
            :tag="titleTag"
            :size="SSectionTitleSize"
            class="text-center"
            :class="SSectionTextColorsClasses[backgroundColor]"
            :classes="SSectionTitleClasses"
            :leading="SSectionTitleLeading"
          >
            {{ title }}
          </TTitle>

          <slot />
        </div>
      </TGrid>
    </TContainer>
  </div>
</template>

<script setup lang="ts">
import type {
  SSectionBackgroundColorsProp,
  SSectionTitleTagProp,
} from './constants'
import {
  SSectionVerticalMarginClasses,
  SSectionverticalPaddingClasses,
  SSectionBackgroundColorsClasses,
  SSectionTextColorsClasses,
  SSectionTitleTag,
  SSectionTitleSize,
  SSectionTitleClasses,
  SSectionTitleLeading,
  SSectionBackgroundColor,
} from './constants'

export interface propsInterface {
  title?: string
  titleTag?: SSectionTitleTagProp
  backgroundColor?: SSectionBackgroundColorsProp
}

withDefaults(defineProps<propsInterface>(), {
  titleTag: SSectionTitleTag,
  backgroundColor: SSectionBackgroundColor,
})
</script>
